
/* ==================================================
   PÄLSVÄNNER – NAMNTRYCK I VARUKORGEN
   TESTVERSION 4 – 2026-10-16

   Stöd för:
   - Vanlig varukorg
   - Utfällbar Debutify-varukorg
   - Synkroniserade antal
   - Borttagning av plagg och namntryck
   - Borttagning av endast namntryck

   Uppdaterar via Debutifys egen varukorgsfunktion
   utan att ladda om hela sidan.

   Standardtryck: 63945877258570
   Reflextryck: 63945877291338
   ================================================== */

(function () {
  'use strict';

  if (window.PVNamntryckCartLoaded) return;
  window.PVNamntryckCartLoaded = true;

  const PRINT_VARIANTS = [
    '63945877258570',
    '63945877291338'
  ];

  let processing = false;

  function shopRoot() {
    return (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) || '/';
  }

  async function request(endpoint, data) {
    const response = await fetch(shopRoot() + endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify(data)
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.description ||
        result.message ||
        'Kunde inte uppdatera varukorgen.'
      );
    }

    return result;
  }

  async function getCart() {
    const response = await fetch(shopRoot() + 'cart.js', {
      credentials: 'same-origin',
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Kunde inte läsa varukorgen.');
    }

    return response.json();
  }

  function isPrint(item) {
    return PRINT_VARIANTS.includes(
      String(item.variant_id)
    );
  }

  function groupOf(item) {
    return item.properties &&
      item.properties._pv_namntryck_grupp
      ? String(item.properties._pv_namntryck_grupp)
      : '';
  }

  function findPair(cart, item) {
    const group = groupOf(item);

    if (!group) return null;

    const members = cart.items.filter(function (entry) {
      return groupOf(entry) === group;
    });

    return {
      garment: members.find(function (entry) {
        return !isPrint(entry);
      }),
      print: members.find(function (entry) {
        return isPrint(entry);
      })
    };
  }

  function cleanProperties(properties) {
    const result = {};

    Object.keys(properties || {}).forEach(function (key) {
      if (
        key === 'Namntryck' ||
        key === 'Tryckfärg' ||
        key === '_pv_namntryck_grupp'
      ) {
        return;
      }

      result[key] = properties[key];
    });

    return result;
  }

  /* =====================================
     TA BORT ENDAST NAMNTRYCKET
     ===================================== */

  async function removePrintOnly(pair) {
    if (!pair.print) return;

    if (!pair.garment) {
      await request('cart/change.js', {
        id: pair.print.key,
        quantity: 0
      });

      return;
    }

    const garment = pair.garment;

    const replacement = {
      id: garment.variant_id,
      quantity: garment.quantity,
      properties: cleanProperties(garment.properties)
    };

    if (
      garment.selling_plan_allocation &&
      garment.selling_plan_allocation.selling_plan
    ) {
      replacement.selling_plan =
        garment.selling_plan_allocation.selling_plan.id;
    }

    // Lägg först till plagget utan namntryck.
    await request('cart/add.js', replacement);

    // Läs om varukorgen innan de gamla raderna tas bort.
    const currentCart = await getCart();

    const oldGarment = currentCart.items.find(function (item) {
      return item.key === garment.key;
    });

    const oldPrint = currentCart.items.find(function (item) {
      return item.key === pair.print.key;
    });

    const updates = {};

    if (oldGarment) {
      updates[oldGarment.key] = 0;
    }

    if (oldPrint) {
      updates[oldPrint.key] = 0;
    }

    if (Object.keys(updates).length > 0) {
      await request('cart/update.js', {
        updates: updates
      });
    }
  }

  /* =====================================
     ÄNDRA ANTAL ELLER TA BORT ARTIKLAR
     ===================================== */

  async function updatePair(pair, sourceItem, quantity) {

    // Endast namntrycket tas bort.
    if (isPrint(sourceItem) && quantity === 0) {
      await removePrintOnly(pair);
      return;
    }

    // Plagget och namntrycket tas bort tillsammans.
    if (!isPrint(sourceItem) && quantity === 0) {
      const updates = {};

      if (pair.garment) {
        updates[pair.garment.key] = 0;
      }

      if (pair.print) {
        updates[pair.print.key] = 0;
      }

      await request('cart/update.js', {
        updates: updates
      });

      return;
    }

    if (!pair.garment || !pair.print) {
      throw new Error(
        'Plagget och namntrycket kunde inte kopplas ihop.'
      );
    }

    const updates = {};

    updates[pair.garment.key] = quantity;
    updates[pair.print.key] = quantity;

    await request('cart/update.js', {
      updates: updates
    });
  }

  /* =====================================
     UPPDATERA DEBUTIFY UTAN SIDOMLADDNING
     ===================================== */

  function refreshCart() {
    return new Promise(function (resolve, reject) {

      if (
        !window.theme ||
        !window.theme.ajaxCart ||
        typeof window.theme.ajaxCart.update !== 'function'
      ) {
        reject(new Error(
          'Debutifys varukorgsfunktion kunde inte hittas.'
        ));
        return;
      }

      let completed = false;

      const timeout = setTimeout(function () {
        if (completed) return;

        completed = true;

        reject(new Error(
          'Varukorgen kunde inte uppdateras i tid.'
        ));
      }, 12000);

      try {
        window.theme.ajaxCart.update(function () {
          if (completed) return;

          completed = true;
          clearTimeout(timeout);
          resolve();
        });
      } catch (error) {
        if (completed) return;

        completed = true;
        clearTimeout(timeout);
        reject(error);
      }
    });
  }

  /* =====================================
     HANTERA KUNDENS ÄNDRINGAR
     ===================================== */

  async function handleQuantity(line, action, input) {
    if (processing) return;

    processing = true;

    try {
      const cart = await getCart();
      const item = cart.items[line - 1];

      if (!item) {
        throw new Error('Kunde inte hitta produkten.');
      }

      const pair = findPair(cart, item);

      if (!pair) {
        throw new Error(
          'Kunde inte hitta kopplingen mellan ' +
          'plagget och namntrycket.'
        );
      }

      let quantity = item.quantity;

      if (action === 'plus') {
        quantity += 1;
      } else if (action === 'minus') {
        quantity -= 1;
      } else if (action === 'remove') {
        quantity = 0;
      } else if (action === 'input') {
        quantity = Number(input.value);
      }

      if (
        !Number.isSafeInteger(quantity) ||
        quantity < 0
      ) {
        throw new Error('Ogiltigt antal.');
      }

      await updatePair(pair, item, quantity);

      // Låt Debutify uppdatera både varukorgslådan
      // och den vanliga varukorgen utan sidomladdning.
      await refreshCart();

    } catch (error) {
      window.alert(
        (error && error.message) ||
        'Något gick fel vid uppdatering av varukorgen.'
      );

      // Ingen automatisk sidomladdning vid fel.
      // Kunden kan uppdatera sidan manuellt vid behov.
    } finally {
      processing = false;
    }
  }

  /* =====================================
     IDENTIFIERA RÄTT VARUKORG
     ===================================== */

  function getCartForm(element) {
    return element.closest(
      '#cartForm, #ajaxCartForm'
    );
  }

  function getGroupedRow(element) {
    const row = element.closest(
      '.cart-item[data-line]'
    );

    if (!row) return null;

    if (!row.hasAttribute('data-pv-namntryck-group')) {
      return null;
    }

    return row;
  }

  /* =====================================
     PLUS, MINUS OCH SOPTUNNA
     ===================================== */

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    const target = event.target;

    if (processing) {
      const control = target.closest(
        '#cartForm .qty-adjust, ' +
        '#cartForm .cart__product-remove, ' +
        '#ajaxCartForm .qty-adjust, ' +
        '#ajaxCartForm .cart__product-remove, ' +
        '#cartForm [name="checkout"], ' +
        '#ajaxCartForm [name="checkout"], ' +
        '#cartForm [type="submit"], ' +
        '#ajaxCartForm [type="submit"]'
      );

      if (control) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      return;
    }

    const button = target.closest(
      '.cart-item .qty-adjust, ' +
      '.cart-item .cart__product-remove'
    );

    if (!button) return;

    const form = getCartForm(button);
    if (!form) return;

    const row = getGroupedRow(button);

    // Låt Debutify sköta vanliga produkter.
    if (!row) return;

    const line = Number(row.dataset.line);

    if (!Number.isSafeInteger(line) || line < 1) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    let action = 'remove';

    if (
      button.classList.contains('qty-plus') ||
      button.classList.contains('js-qty__adjust--plus')
    ) {
      action = 'plus';
    } else if (
      button.classList.contains('qty-minus') ||
      button.classList.contains('js-qty__adjust--minus')
    ) {
      action = 'minus';
    }

    handleQuantity(line, action);

  }, true);

  /* =====================================
     MANUELL ÄNDRING AV ANTAL
     ===================================== */

  document.addEventListener('change', function (event) {
    if (!(event.target instanceof Element)) return;

    const input = event.target;

    if (!input.matches(
      '.cart__product-qty, ' +
      '.ajaxcart__qty-num, ' +
      '.qty-input'
    )) {
      return;
    }

    const form = getCartForm(input);
    if (!form) return;

    const row = getGroupedRow(input);
    if (!row) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (processing) return;

    handleQuantity(
      Number(row.dataset.line),
      'input',
      input
    );

  }, true);

})();
